import * as React from 'react'

import {useDerivedState} from '../../../../../../../hocs/withDerivedState'
import {getSingleBuildArg} from '../../../../../../../rest/builds'
import {getBuildLocator} from '../../../../../../../rest/locators'
import {getBuild} from '../../../../../../../selectors'
import {restApi} from '../../../../../../../services/rest'
import type {BuildId} from '../../../../../../../types'
import BuildsWrapped, {
  BuildsWrappedPlaceholder,
} from '../../../../../../common/Builds/Builds.wrapped'
import RowGroupsWrapper from '../../../../../../common/Grid/RowGroupsWrapper'
import {useVisibility} from '../../../../../../common/Visible/Visible.hooks'

import styles from './VisibleBuild.css'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  buildId: BuildId
  hasParentGrid?: boolean
}
export default function VisibleBuild({buildId, hasParentGrid}: Props) {
  const ref = React.useRef<HTMLDivElement>(null)
  const isVisible = useVisibility(ref)
  const wasVisible = useDerivedState(false, state => state || isVisible)
  const isReady = useAppSelector(state => getBuild(state, buildId) != null)
  restApi.endpoints.getBuildNormalized.useQuerySubscription(
    getSingleBuildArg(getBuildLocator(buildId), {
      withRunningInfo: true,
    }),
    {
      skip: !wasVisible,
    },
  )
  return (
    <RowGroupsWrapper>
      <div ref={ref} className={styles.visibilityDetector} />
      {isReady && wasVisible ? (
        <BuildsWrapped buildIds={[buildId]} hasParentGrid={hasParentGrid} />
      ) : (
        <BuildsWrappedPlaceholder hasParentGrid={hasParentGrid} />
      )}
    </RowGroupsWrapper>
  )
}
